"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyLocale = exports.getLocale = void 0;
const getLocale = (brand) => {
    switch (brand) {
        case 'PILOT':
        case 'KIN':
        case 'SOFTWARE':
        case 'JUNIPER':
            return new Intl.Locale('en-AU');
        case 'JUNIPER_DE':
            return new Intl.Locale('de-DE');
        case 'COMPOUND_UK':
        case 'JUNIPER_UK':
        case 'JUNIPER_JP':
            return new Intl.Locale('en-GB');
        default:
            throw new Error(`unsupported brand for locale: ${brand}`);
    }
};
exports.getLocale = getLocale;
const getCurrencyLocale = (brand) => {
    switch (brand) {
        case 'JUNIPER_JP':
            return 'ja-JP';
        default:
            return (0, exports.getLocale)(brand).toString();
    }
};
exports.getCurrencyLocale = getCurrencyLocale;
